import { ComponentProps } from "react";
import { cn } from "../../../lib/utils";

function Skeleton({ className, ...props }: ComponentProps<"div">) {
  return (
    <div data-slot="skeleton" className={cn("rounded-md bg-[#F4F4F5] relative overflow-hidden", className)} {...props}>
      <div
        className="absolute inset-0"
        style={{
          background: "linear-gradient(90deg, #F4F4F5 0%, #F4F4F5 30%, #E4E4E7 50%, #F4F4F5 70%, #F4F4F5 100%)",
          width: "200%",
          height: "100%",
          animation: "shimmer 2s infinite ease-in-out"
        }}
      />
    </div>
  );
}

export { Skeleton };
